<h4 class="flex flex-col sm:flex-row flex-wrap gap-5 items-stretch justify-start">
    <div class="flex flex-row gap-5">
        @if (back()) {
            <a aria-hidden="true" class="items-center pr-5 flex link separator-right" (click)="historyBack()">
                <mat-icon class="position">chevron_left</mat-icon>
                <span class="hidden sm:block back-text">
                    {{ 'buttons.INDIETRO' | transloco | capitalizeFirst }}
                </span>
            </a>
        }
        @if (!value()) {
            <div class="color-primary-contrast">
                <b>{{ title() | transloco | capitalizeFirst }}</b>
            </div>
        } @else {
            <div class="color-primary-contrast">
                <b>{{ title() | transloco | capitalizeFirst }}:</b>
                @if(translateValue()) {
                    <span class="color-value">
                        {{ ' ' + (capitalizeFirst() ? (value() | capitalizeFirst | transloco) : (value() | transloco)) }}
                    </span>
                } @else {
                    <span class="color-value">
                        {{ ' ' + (capitalizeFirst() ? (value() | capitalizeFirst) : value()) }}
                    </span>
                }
            </div>
        }
        @if (infoText()) {
            <div class="flex items-end">
                <mat-icon class="cursor-pointer" color="accent" (click)="showInfos = !showInfos"
                          [matTooltip]="'title.info' | transloco">info
                </mat-icon>
            </div>

        }
    </div>

    @if (feedback()) {
        <div class="flex feedback-button items-end flex-row gap-2" [ngClass]="{'cursor-pointer': goToFeedback()}"
             [routerLink]="[goToFeedback() ? 'feedback': '.']">
            <div class="flex gap-0.5">
                @for (star of [1, 2, 3, 4, 5]; track star) {
                    <div class="star">
                        @if (star <= starAverage()) {
                            <img ngSrc="assets/images/full_star.svg" width="18" height="18" alt="">
                        } @else if (star - starAverage() === 0.5) {
                            <img ngSrc="assets/images/half_star.svg" width="18" height="18" alt="">
                        } @else if ((star > starAverage()) && (star - starAverage() !== 0.5)) {
                            <img ngSrc="assets/images/empty_star.svg" width="18" height="18" alt="">
                        }
                    </div>
                }
            </div>
            <span class="star-average">{{ starAverage() }}/5</span>
            <span [ngClass]="{'hover-underline-animation': goToFeedback()}">
                {{ reviewsNumber() }} {{ 'buttons.feedback' | transloco | capitalizeFirst }}
            </span>
        </div>
    }
</h4>
@if (showInfos) {
    <div class="absolute -mt-6" [@slideInOut]="">
        <small class="color-light-text">{{ infoText() | transloco }}</small>
    </div>
}
